import { render, staticRenderFns } from "./CourseCardPreviewIa.vue?vue&type=template&id=155ff842&scoped=true"
import script from "./CourseCardPreviewIa.vue?vue&type=script&lang=js"
export * from "./CourseCardPreviewIa.vue?vue&type=script&lang=js"
import style0 from "./CourseCardPreviewIa.vue?vue&type=style&index=0&id=155ff842&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "155ff842",
  null
  
)

export default component.exports